"use client";
import { ApiMessageHandler, ArtAlert, DynamicForm, useApiService, withFormService, validators } from "@art/shared-ui";
import { useState } from "react";


function ArtProjectsAddPage({ data, onSave, onInit }: any) {
   const apiService = useApiService();
   const [saveError, setSaveError] = useState("");



   const formBuilder = (data: any) => {
      return [
         {
            type: 'hidden',
            id: 'id',
            value: data?._id
         },
         {
            type: 'row',
            children: [
               {
                  type: 'col',
                  classNames: ['col-12'],
                  children: [
                     {
                        id: "title",
                        label: "Project Name",
                        type: "text",
                        marginBottom: "0px",
                        placeholder: "Enter your project name",
                        required: true,
                        value: data?.title,
                        validate: validators((value) => {
                           if (!value || value.trim() === "") {
                              return "Project name is required.";
                           }
                           if (/[^a-zA-Z0-9]/.test(value)) {
                              return "Project name can only contain alphanumeric characters.";
                           }
                           if (value.length < 3 || value.length > 20) {
                              return "Name must be between 3-20 characters."
                           }
                           return null;
                        })
                     },
                  ]
               }
            ]
         },
      ]
   };

   return <>
      {saveError && <ArtAlert severity="error" sx={{ mb: 2 }}>{saveError}</ArtAlert>}
      <DynamicForm formBuilder={formBuilder} onInit={onInit}
         onSubmit={apiService.saveData(data ? `/projects/${data.id}` : "/projects", data ? "put" : "post", {
            onApiCall: (values) => {
               setSaveError("");
               return values;
            },
            onSuccess: () => onSave(),
            onError: (error: unknown) => setSaveError(ApiMessageHandler.extractErrorMessage(error)),
         })} />
   </>

}

export default withFormService(ArtProjectsAddPage);
